import {Component} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {funcNavigate} from "../../../../settings/utils/functions";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";
import {translation} from "../../../../settings/translate/fa";

class NotFound extends Component {
    static contextType = simplyContext

    componentDidMount() {
        this.context.fReset()
        this.context.fPreloader(false)
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context)
    }


    render() {

        return (
            <HelmetProvider>
                <Helmet>
                     <title>یافت نشد</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/یافت-نشد"}/>
                </Helmet>

                <div className='container-fluid cFlex1'>

                    {header(this.context)}

                    <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                        <div className='cContainer col-12'>
                            <div className='row justify-content-center'>
                                <div className='col-12 lh-lg'>
                                    <NavLink to={urlDynamic.path.homeFa} className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                        اصلی</NavLink>
                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                    <h1 className='cColor2 mb-0 lh-lg d-inline-block cFontSize13'>{translation.msgError404}</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row py-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                        <div className='cContainer col-12'>
                            <div className='row justify-content-center'>
                                <div className='col-12 cZindex2'>
                                    <div className='p-5 cBg10 rounded rounded-3'>
                                        <p className='text-center mb-0 cFontSize14_768 cFontSize16 cColor2 fw-bold lh-lg'>{translation.msgError404}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    {footer()}


                </div>

            </HelmetProvider>
        )
    }
}

export default withRouter(NotFound)